import React, { useState, useEffect } from "react";
import TeacherVideoCard from "./TeacherVideoCard";
import TeacherTagsList from "./TeacherTagList";
import { deleteVideo } from "../Services/AllServices";
import { useNavigate } from "react-router-dom";

const TeacherManageVideos = ({ videos: initialVideos = [] }) => {
  const [videos, setVideos] = useState(initialVideos);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const navigate = useNavigate();

  const handleVideoClick = (video) => {
    if (video) {
      navigate("/videoplayer", { state: { video, videos } });
    }
  };

  useEffect(() => {
    setVideos(initialVideos || []); // Ensure videos is an array
  }, [initialVideos]);

  const openModal = (video) => {
    setSelectedVideo(video);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedVideo(null);
  };

  const removeVideo = async (videoId) => {
    console.log(`Removing video with ID: ${videoId}`);
    try {
      const formData = { video_id: videoId };
      await deleteVideo(formData, (response) => {
        if (response.status === "success") {
          console.log("Deleted video successfully");
          setVideos((prevVideos) =>
            prevVideos.filter((video) => video._id !== videoId)
          );
          closeModal();
        } else {
          console.log("Failed to delete the video");
        }
      });
    } catch (error) {
      console.log("Failed to delete the video", error);
    }
  };

  const sortedVideos = Array.isArray(videos)
    ? videos.sort((a, b) => new Date(b.upload_date) - new Date(a.upload_date))
    : [];

  return (
    <div className="content-section">
      <div className="teacher_video-analysis">
        <h2>Videos</h2>
        <div className="teacher_videos-list">
          {sortedVideos.length > 0 ? (
            sortedVideos.map((video, index) => (
              <TeacherVideoCard
                key={video.id || index}
                video={video}
                openModal={openModal}
                isModalOpen={isModalOpen && selectedVideo === video}
                closeModal={closeModal}
                removeVideo={() => removeVideo(video._id)}
                handleVideoClick={() => handleVideoClick(video)}
              />
            ))
          ) : (
            <div
              className="no-videos-message"
              style={{
                textAlign: "center",

                whiteSpace: "nowrap",
              }}
            >
              No videos created yet.
            </div>
          )}
        </div>
      </div>
      {sortedVideos.length > 0 && <TeacherTagsList />}
    </div>
  );
};

export default TeacherManageVideos;
